export default {
    methods: {
        showAlert(title = undefined, text = '', confirmButtonText = 'OK', confirmCallback = undefined, cancelCallback = undefined) {
            this.$alert(text, title, {
                confirmButtonText: confirmButtonText,
                callback: action => {
                  if(cancelCallback && action === 'cancel') {
                    cancelCallback()
                  } else if(confirmCallback) {
                    confirmCallback()
                  }
                },
                closeOnClickModal: true
              });
        },
        showConfirmation(title = undefined, text = '', confirmButtonText = 'OK',  cancelButtonText = 'Abbrechen', confirmCallback = undefined, cancelCallback = undefined) {
          this.$confirm(text, title, {
              confirmButtonText: confirmButtonText,
              cancelButtonText: cancelButtonText,
              callback: action => {
                if(cancelCallback && action === 'cancel') {
                  cancelCallback()
                } else if(confirmCallback && action === 'confirm') {
                  confirmCallback()
                }
              },
              closeOnClickModal: true
            });
      }
    }
}